<script setup lang="ts">
import { ref, defineProps } from 'vue';

defineProps<{
  dropdownItems?: Array<{
    id: string;
    label: string; // Allow title to be a render function
    onClick: () => void;
  }>;
}>();

const dropdownActive = ref(false);

const toggleDropdown = () => {
  dropdownActive.value = !dropdownActive.value;
};

const closeDropdown = () => {
  dropdownActive.value = false;
};
</script>

<template>
  <button
    v-click-away="closeDropdown"
    class="btn btn-secondary btn-default has relative min-w-[100px]"
    :class="{ 'active bg-[#424242]': dropdownActive }"
    title="More"
    @click.stop="toggleDropdown">
    <slot />

    <div class="gemx-dropdown-list" :class="{ show: dropdownActive }">
      <slot name="dropdown">
        <template v-for="item in dropdownItems" :key="item.id">
          <a :id="item.id" class="gemx-dropdown-item typo-button14 typo-medium" @click.stop="item.onClick">
            {{ item.label }}
          </a>
        </template>
      </slot>
    </div>
  </button>
</template>

<style scoped>
.gemx-dropdown-list {
  @apply hidden flex-col bg-dark-300 absolute w-fit min-w-[160px] z-[2] shadow-[0px_-2px_8px_rgba(0,0,0,0.06),0px_2px_8px_rgba(0,0,0,0.12)] left-0 top-[45px] before:content-[''] before:absolute before:top-[-5px] before:w-0 before:h-0 before:rotate-45 before:z-[-1] before:rounded-[3px] before:border-8 before:border-solid before:border-dark-300 before:left-5;
}

.gemx-dropdown-list.show {
  @apply flex;
}

.gemx-dropdown-item {
  @apply flex flex-row items-center justify-start cursor-pointer px-4 py-3 hover:bg-[#424242];
}

/* eslint-disable-next-line vue-scoped-css/no-unused-selector */
.gemx-dropdown-item.disabled {
  @apply opacity-40 cursor-default;
}

/* eslint-disable-next-line vue-scoped-css/no-unused-selector */
.gemx-dropdown-item:not(.disabled).gf-disabled_action:hover {
  @apply bg-[#606569];
}
</style>
